import { useEffect, useState } from "react";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { StrikeMarquee } from "@/components/StrikeMarquee";
import { Events } from "@/components/Events";
import { Roster } from "@/components/Roster";
import { Manifesto } from "@/components/Manifesto";
import { Join } from "@/components/Join";
import { Sponsors } from "@/components/Sponsors";
import { Team } from "@/components/Team";
import { Footer } from "@/components/Footer";
import { getContent, getEvents, getFighters } from "@/lib/api";
import { DEFAULT_SPONSORS, DEFAULT_TEAM_MEMBERS, resolveSection } from "@/lib/contentDefaults";

export default function Home() {
  const [events, setEvents] = useState([]);
  const [fighters, setFighters] = useState([]);
  const [content, setContent] = useState({ sections: {}, sponsors: [], team_members: [] });
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [loadingFighters, setLoadingFighters] = useState(true);
  const [contentLoaded, setContentLoaded] = useState(false);

  useEffect(() => {
    getEvents()
      .then(setEvents)
      .catch((e) => console.error("events", e))
      .finally(() => setLoadingEvents(false));
    getFighters()
      .then(setFighters)
      .catch((e) => console.error("fighters", e))
      .finally(() => setLoadingFighters(false));
    getContent()
      .then((data) => {
        setContent(data || { sections: {}, sponsors: [], team_members: [] });
        setContentLoaded(true);
      })
      .catch((e) => console.error("content", e));
  }, []);

  const section = (key) => resolveSection(content.sections, key, contentLoaded);
  const sponsors = contentLoaded ? content.sponsors || [] : DEFAULT_SPONSORS;
  const teamMembers = contentLoaded ? content.team_members || [] : DEFAULT_TEAM_MEMBERS;

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain" data-testid="app-root">
        <Navbar section={section("navigation")} />
        <main>
          <Hero section={section("hero")} />
          <StrikeMarquee section={section("marquee")} />
          <Events events={events} loading={loadingEvents} section={section("events")} />
          <Roster fighters={fighters} loading={loadingFighters} section={section("roster")} />
          <Manifesto section={section("manifesto")} />
          <Join section={section("join")} />
          <Sponsors section={section("sponsors")} sponsors={sponsors} />
          <Team section={section("team")} members={teamMembers} />
        </main>
        <Footer section={section("footer")} />
      </div>
    </ReactLenis>
  );
}
